"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable implicit-arrow-linebreak */
/**
 * Schema for a Dynamic Annotation
 * @returns Array with Collection name and defined Schema
 */
var DynamicAnnotation = function DynamicAnnotation() {
  return ['DynamicAnnotation', {
    name: {
      type: String,
      required: true
    },
    className: {
      type: String,
      required: true
    },
    group: {
      type: String
    },
    tag: {
      type: String,
      required: true
    },
    createdBy: {
      type: String
    },
    createdAt: {
      type: Date,
      required: true
    },
    updatedAt: {
      type: Date
    }
  }];
};
var _default = DynamicAnnotation;
exports["default"] = _default;